import { Box, Button, Divider, Typography } from "@mui/material";

export const RedirectHelpPage = (): JSX.Element => {
    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f5f5f5"
        >
            <Box
                bgcolor="white"
                borderRadius={2}
                p={5}
                maxWidth={520}
                width="100%"
                boxShadow={3}
            >
                <Typography variant="h5" gutterBottom style={{ fontWeight: 700 }}>
                    You&apos;ve been redirected here
                </Typography>

                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                    This is a temporary redirect page for known issues. You may have arrived here because of one of the following:
                </Typography>

                <Box pl={2} mb={3}>
                    <Typography variant="body2" style={{ marginBottom: 8 }}>
                        1. You clicked <strong>Logout</strong> and were sent to this page instead of the login screen.
                    </Typography>
                    <Typography variant="body2" style={{ marginBottom: 8 }}>
                        2. You tried to access the <strong>Curriculum Mapper</strong> with a role that does not have mapper access (e.g. teacher, student, or parent).
                    </Typography>
                    <Typography variant="body2">
                        3. Another known session or permission issue occurred.
                    </Typography>
                </Box>

                <Divider style={{ marginBottom: 24 }} />

                <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                    Please click one of the buttons below to return:
                </Typography>

                <Box display="flex" style={{ gap: 12, flexWrap: "wrap" }}>
                    <Button
                        variant="contained"
                        color="primary"
                        // @ts-ignore
                        onClick={() => { window.location.href = process.env.REACT_APP_PLATFORM_URL || ""; }}
                    >
                        Platform Portal
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        // @ts-ignore
                        onClick={() => { window.location.href = process.env.REACT_APP_WEBSITE_URL || ""; }}
                    >
                        Website
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        // @ts-ignore
                        onClick={() => { window.location.href = process.env.REACT_APP_MAPPER_URL || ""; }}
                    >
                        Curriculum Mapper
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};
